




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Field, Popup, Picker } from "vant";

@Component({
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  }
})
export default class CustomSelect extends Vue {
  showPicker = false;
  oValue = "";

  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  private vertical;

  @Prop({
    type: String,
    default() {
      return "";
    }
  })
  private label;

  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  private required;

  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  private columns;

  @Prop({
    type: [String, Number],
    default() {
      return "";
    }
  })
  private value;

  @Watch("value")
  watchValue(val) {
    const res = this.columns.find(item => {
      return item.value == val;
    });
    this.oValue = (res && res.text) || "";
  }

  get oLabel() {
    return this.vertical ? "" : this.label;
  }

  handleConfirm(item) {
    
    this.oValue = item.text;
    this.$emit("input", item.value);
    this.showPicker = false;
  }
}
